import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import MaskedInput from 'react-text-mask';
import { Input, Label } from 'semantic-ui-react';
import classnames from 'classnames/bind';
import { commonPropTypes, formFieldWrapper } from '../formFieldWrapper';
import createAutoCorrectionTimePipe from '../../../utils/createAutoCorrectionTimePipe';
import styles from '../styles.scss';
const cx = classnames.bind(styles);
const TimeField = formFieldWrapper((fieldProps, showError) => {
    const { elmId, label, placeholder, inputLabel, onChange, onBlur, onFocus, value, compact, className, keepCharPositions = true, includeSeconds = false, ...rest } = fieldProps;
    const newClassName = classnames({
        compact,
        labeled: inputLabel,
        [className]: true,
    });
    const timeFormat = includeSeconds ? 'HH:MM:SS A' : 'HH:MM A';
    const mask = timeFormat.split('').reduce((mask, char) => {
        switch (char) {
            case 'H':
            case 'M':
            case 'S':
                return [...mask, /\d/];
            case ':':
                return [...mask, ':'];
            case 'A':
                return [...mask, ' ', /[aApP]/, 'M'];
            default:
                return mask;
        }
    }, []);
    return (_jsxs(Input, { error: showError, "data-elm-id": `${elmId}_input`, className: newClassName, ...rest, children: [!!inputLabel && _jsx(Label, { children: inputLabel }), _jsx(MaskedInput, { className: cx('masked-input'), mask: mask, keepCharPositions: keepCharPositions, placeholder: placeholder || (includeSeconds ? 'Ex. 03:15:45 PM' : 'Ex. 03:15 PM'), pipe: createAutoCorrectionTimePipe(timeFormat), onChange: onChange, onBlur: onBlur, onFocus: onFocus, value: value })] }));
});
TimeField.propTypes = {
    ...commonPropTypes,
    includeSeconds: PropTypes.bool,
    keepCharPositions: PropTypes.bool,
};
export default TimeField;
//# sourceMappingURL=index.js.map